export default {
  selectable: false,
  multiselectable: false,
  focusable: false,
};
